import { KIOSK_CONCIERGE_ROLLOUT_FLAG } from '@dutchie/common/utils/concierge-rollout';
import { useLatchedFlag } from 'src/hooks/use-latched-flag';
import { isKioskConciergeSettingOn, useIsKioskConciergeEnabled } from './use-is-kiosk-concierge-enabled';
import { useIsLdContextForDispensary } from './use-is-ld-identified-for-dispensary';

type Dispensary = Parameters<typeof useIsKioskConciergeEnabled>[0];

/**
 * Gate for kiosk chrome that changes only on the kiosk Concierge route (Pro layout box).
 * Latched like the footer in CoreMenuLayout and ConciergePage: once the flag is seen on while LD
 * is identified with this store, a late identify that drops it cannot switch the chrome off under
 * the open page, and another store's still-live flag cannot latch. The scope is this route visit
 * for this store, so leaving the route clears it and the kill switch applies on the next navigation.
 */
export function useIsKioskConciergeChromeActive(dispensary: Dispensary, isOnRoute: boolean): boolean {
  const isKioskConciergeEnabled = useIsKioskConciergeEnabled(dispensary);
  const isLdContextForDispensary = useIsLdContextForDispensary(dispensary?.id);
  const isFlagLatched = useLatchedFlag(
    KIOSK_CONCIERGE_ROLLOUT_FLAG,
    isOnRoute ? `concierge:${dispensary?.id ?? ''}` : null,
    isOnRoute && isLdContextForDispensary
  );
  return isOnRoute && (isKioskConciergeEnabled || isFlagLatched) && isKioskConciergeSettingOn(dispensary);
}
